import { Box } from '@mui/material';
import React from 'react';

interface ErrorBadgeProps {
  count: number;
  onClick?: () => void;
  collapsed?: boolean;
}

const ErrorBadge: React.FC<ErrorBadgeProps> = ({
  count,
  onClick,
  collapsed,
}) => {
  const stylesCollapsed = {
    position: 'absolute',
    left: '34px',
    bottom: '28px',
    width: '8px',
    height: '8px',
    backgroundColor: 'error.main',
    borderRadius: '12px',
  };
  return (
    <Box
      component="span"
      onClick={(event) => {
        if (onClick) {
          event.stopPropagation();
          onClick();
        }
      }}
      sx={
        collapsed
          ? stylesCollapsed
          : {
              backgroundColor: 'error.main',
              color: 'primary.contrastText',
              borderRadius: '12px', // Increased for a pill shape
              padding: collapsed ? '0px' : '0 6px', // Horizontal padding only
              fontSize: '12px',
              lineHeight: '18px', // Match this to the text line-height
              display: 'inline-flex',
              alignItems: 'center',
              height: collapsed ? '0px' : '18px', // Set a fixed height to match text
              minWidth: '18px', // Ensure circular shape for single-digit numbers
              justifyContent: 'center',
            }
      }
    >
      {collapsed ? '' : count}
    </Box>
  );
};

export default ErrorBadge;
